import React from 'react';
import Hero from './components/Hero';
import LatestNews from './components/LatestNews';
import EventsCalendar from './components/EventsCalendar';
import MediaContact from './components/MediaContact';

export default function News() {
  return (
    <div className="bg-white">
      <Hero />
      <LatestNews />
      <EventsCalendar />
      <MediaContact />
    </div>
  );
}